import React, { Component } from "react";
import PropTypes from "prop-types";
import { observer, inject } from "mobx-react";
import { redirect, formatPGparamsRP } from "../../../utils";
import Analytics from "../../../analytics";
import Event from "../../../analytics/eventFactory";


@inject('RazorpayStore', 'PaymentStore')
@observer
class RazorPay extends Component {
  constructor(props) {
    super(props);
    this.initRazorPay = this.initRazorPay.bind(this);
    this.onPaymentValidate = this.onPaymentValidate.bind(this);
  }
  onPaymentValidate({ razorpay_payment_id = "" }, transactionId) {
    const successBody = {
      transactionId,
      requestParams: {
        'razor_pay_transaction_id': razorpay_payment_id
      }
    }
    this.props.RazorpayStore.onPaymentValidate(successBody);
  }
  initRazorPay() {
    const { formData, componentName } = this.props;
    const { orderId, transactions: { banking } } = formData;
    const { transactionId, requestParameters } = banking;
    const razorpayArgs = formatPGparamsRP(requestParameters);
    this.props.RazorpayStore.loadRazorpay(componentName, razorpayArgs, formData)
      .then(res => {
        Analytics.trackEvent({
          action: Event.action.RAZORPAY_SUCCESS,
          category: Event.category.PAYMENT,
          label: Event.label.getRazorpaySuccess(res),
        });
        this.onPaymentValidate(res, transactionId);
        redirect(`orderconfirmation/${orderId}/success`);
      })
      .catch(err => {
        Analytics.trackEvent({
          action: Event.action.RAZORPAY_FAILURE,
          category: Event.category.PAYMENT,
          label: Event.label.getRazorpayFailure(err),
        });
        this.onPaymentValidate(err, transactionId);
        redirect(`checkout/onpaymentfailure`);
      });
  }
  componentDidMount() {
    this.initRazorPay();
  }
  render() {
    return null;
  }
}

RazorPay.propTypes = {
  RazorpayStore: PropTypes.shape({
    onPaymentValidate: PropTypes.func.isRequired,
    loadRazorpay: PropTypes.func.isRequired,
  }),
  formData: PropTypes.shape({
    transactions: PropTypes.shape({
      banking: PropTypes.shape({}),
    }).isRequired,
  }).isRequired,
  componentName: PropTypes.string.isRequired,
}

const getFinalComponent = component => component;

const ProjectComponent = {
  getFinalComponent,
  component: RazorPay,
  wrapper: RazorPay,
}

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/PaymentGateway/RazorPay/index.js